import { AfterViewInit, Component } from '@angular/core';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
})
export class PublicComponent implements AfterViewInit {
  /**
   * The ScrollSmoother instance
   */
  private scrollSmoother!: ScrollSmoother;

  ngAfterViewInit(): void {
    this.scrollSmoother = new ScrollSmoother({
      wrapper: '.smooth-wrapper',
      content: '.smooth-content',
      smooth: 1,
      smoothTouch: 0.1,
      effects: true,
    });
  }
}
